class AddOns extends HTMLElement {
    constructor() {
        super();
        const self = this;
        this.attachments = [];
        this.addedVariants = [];
        this.attachmentOptions = [];
        this.cartNotification = document.getElementById('s-cart-notification');
        this.cartItems = document.querySelector('cart-items');
        this.isCartPage = window.location.pathname === '/cart';
        this.productForm = document.querySelector('product-form');
        this.activeSelect = document.querySelector('.c-add-ons__select.c-field__select');
        this.num = 1;
        document.querySelectorAll('[name="attachments"]').forEach(function (element) {
            element.addEventListener('change', function () {
                self.recalculate(self);
            });
            element.addEventListener('input', function () {
                self.changeInputValue(element);
            })
        })
        document.querySelector('[name="quantity"]').addEventListener('input', function () {
            self.recalculate(self);
        })
        document.querySelector('[name="quantity"]').addEventListener('change', function () {
            self.recalculate(self);
          
            document.querySelectorAll('[name="attachments"]').forEach(function (element) {
              if(element.dataset.handleValue == "centennial-seal" || element.dataset.handleValue == "flame-stop-ii") {
                self.addOnMinus(element,null);
              }
            });
        })
        document.querySelector('[data-add-ons-button]').addEventListener('click', function (e) {
            e.preventDefault();
            this.setAttribute('aria-disabled', true);
            this.classList.add('loading');
            document.querySelector('.loading-overlay').classList.remove('loading-overlay_d-none');
            self.addItemsToCart(self.addedVariants, self);

        })
        document.querySelectorAll('[data-color-item]').forEach(function (element) {
            element.addEventListener('click', function () {
                self.changeProduct(element);
                self.changeActiveColor(element);
            })
        })
        document.querySelectorAll('.c-add-ons__select').forEach(function (item) {
            item.addEventListener('change', function () {
                self.selectChange(item);
            })
        })
        document.querySelector('[data-color-input]').addEventListener('click', function () {
            self.dropdownToggle();
        })

        this.setSelectEvent();

        document.querySelector('[data-product-qty]').addEventListener('change', function () {
            self.changeInput();
        })

        //CN - suggest box qty + warning
        document.querySelectorAll('[name="attachments"]').forEach(function (element) {
            if(element.dataset.handleValue == "centennial-seal" || element.dataset.handleValue == "flame-stop-ii") {
                element.addEventListener('change', (event) => { self.addOnMinus(element, event); } );
                let minus = element.closest('.c-add-ons__c-quantity').querySelector('button[name="minus"]');
                let plus = element.closest('.c-add-ons__c-quantity').querySelector('button[name="plus"]');
                if(minus != null)
                {
                  minus.addEventListener('click', (event) => { self.addOnMinus(element, event); } );
                }
                if(plus != null)
                {
                  plus.addEventListener('click', (event) => { self.addOnPlus(element, event); } );
                }
              
            }
        })

        setTimeout(function () {
            self.activeSelect.value = self.activeSelect.querySelector('[data-variant-id]').value.trim();
            initSelect();
            self.recalculate(self);
        }, 3000)
    }

    recalculate(self) {
        self.attachments = [];
        self.addedVariants = [];
        self.attachmentOptions = [];
        const priceElement = document.querySelector('[data-product-price]');
        const oldPriceElement = document.querySelector('[data-product-old-price]');
        let currencySymbol = Array.from(priceElement.getAttribute('data-product-price'))[0];
        let priceValue = Number(priceElement.getAttribute('data-product-price').replace(currencySymbol, '').replace(' ','').replace(',',''));
        let oldPriceValue = Number(oldPriceElement.getAttribute('data-product-old-price').replace(currencySymbol, '').replace(' ','').replace(',',''));
        const inputValue = Number(document.querySelector('[data-product-qty]').value);
        priceValue = priceValue * inputValue;
        oldPriceValue = oldPriceValue * inputValue;
     
        document.querySelectorAll('[name="attachments"]').forEach(function (item) {
            if (item.value > 0) {
                self.attachments.push(item);
                self.addedVariants.push({
                    'id': item.getAttribute('data-id'),
                    'quantity': item.value,
                })
            }
        })
        this.attachments.forEach(function (item) {
            self.attachmentOptions.push('attachment:' + item.getAttribute('data-handle-value') + ':' + item.value + ':' + item.getAttribute('data-id') + ':' + self.num);
            priceValue += Number(item.getAttribute('data-price')) * Number(item.value);
            if (item.getAttribute('data-old-price').length) {
                oldPriceValue += Number(item.getAttribute('data-old-price')) * Number(item.value);
            } else if (Number(oldPriceValue) > 0) {
                oldPriceValue += Number(item.getAttribute('data-price')) * Number(item.value);
            }
        })
        priceElement.textContent = currencySymbol + priceValue.toFixed(2);
        if (Number(oldPriceValue) > 0) {
            oldPriceElement.textContent = currencySymbol + oldPriceValue.toFixed(2);
        }
    }

    changeInput() {
        this.recalculate(this);
    }

    changeInputValue(element) {
        element.value = Number(element.value).toString();
    }

    addOnMinus(element, event) {
      //if the add on qty is greater than 0 but less than the main product qty, show a warning
      let mainQty = document.querySelector('[name="quantity"]').value;
      let warningEl = element.closest('.c-add-ons__product-container').querySelector('.add-ons__qtyWarning');
      
      if(element.value > 0) {
        if(element.value < mainQty) {
          warningEl.innerHTML = "Heads Up! You've selected " + mainQty + " boxes of reclaimed wood planks but only " + element.value + " boxes of " + element.dataset.handleValue.replaceAll('-',' ');
          warningEl.classList.remove('hidden');
        } else {
          warningEl.innerHTML = "";
          warningEl.classList.add('hidden');
        }
      } else {
          warningEl.innerHTML = "";
          warningEl.classList.add('hidden');
      }
    }

    addOnPlus(element, event) {
      //if the main product qty is more than 1, match the add on qty to the main product qty by default
      let mainQty = document.querySelector('[name="quantity"]').value;
      let warningEl = element.closest('.c-add-ons__product-container').querySelector('.add-ons__qtyWarning');
      
      if(element.value == 1 && mainQty > 1) {
        element.value = mainQty;
        this.recalculate(this);
      }

      if(element.value == 0 || element.value >= mainQty){
        warningEl.innerHTML = "";
        warningEl.classList.add('hidden');
      }

    }

    changeProduct(element) {
        const productId = element.getAttribute('data-product-id');
        const activeSelect = document.getElementById('product-ref-' + productId);
        const variantId = activeSelect.options[activeSelect.selectedIndex].getAttribute('data-variant-id');
        const inputElement = activeSelect.closest('.c-add-ons__product').querySelector('[name="attachments"]')
        const variantHandle = activeSelect.options[activeSelect.selectedIndex].getAttribute('data-handle');
        document.querySelectorAll('.c-add-ons__select').forEach(function (item) {
            item.classList.add('c-add-ons__select_hidden');
            item.classList.remove('c-field__select');
        })
        activeSelect.classList.remove('c-add-ons__select_hidden');
        activeSelect.classList.add('c-field__select');
        activeSelect.value = activeSelect.querySelector('[data-variant-id]').value.trim();
        initSelect();
        this.setSelectEvent();
        inputElement.value = '0';
        inputElement.setAttribute('data-id', variantId);
        inputElement.setAttribute('data-handle-value', variantHandle);
    }

    changeActiveColor(element) {
        document.querySelectorAll('[data-color-item]').forEach(function (item) {
            item.classList.remove('is-selected');
        })
        element.classList.add('is-selected');
        document.querySelector('[data-color-text]').innerHTML = element.getAttribute('data-value');
        document.querySelector('[data-color-select]').classList.toggle('is-active');
        this.recalculate(this);
    }

    selectChange(element) {
        const variantId = element.options[element.selectedIndex].getAttribute('data-variant-id');
        const variantHandle = element.options[element.selectedIndex].getAttribute('data-handle');
        const inputElement = element.closest('.c-add-ons__product').querySelector('[name="attachments"]');
        inputElement.setAttribute('data-id', variantId);
        inputElement.setAttribute('data-handle-value', variantHandle);
        this.recalculate(this);
    }

    setSelectEvent() {
        const self = this;
        $('.c-field__select').unbind('select2:select').bind('select2:select', function (e) {
            const thisVal = $(this).next('.select2-container').find('.select2-selection__rendered').html().trim();
            $(this).val(thisVal);
            const option = $(this).find('option[value="' + thisVal + '"]');
            self.optionChanged(option);
        })
    }

    dropdownToggle() {
        document.querySelector('[data-color-select]').classList.toggle('is-active');
    }

    optionChanged(option) {
        const variantId = option.attr('data-variant-id');
        const variantHandle = option.attr('data-handle');
        const inputElement = option.closest('.c-add-ons__product').find('[name="attachments"]');
        inputElement.attr('data-id', variantId);
        inputElement.attr('data-handle-value', variantHandle);
        this.recalculate(this);
    }

    addItemsToCart(addedVariants, self) {
        Shopify.itemsQueue = [];
        let data = {
            'id': document.querySelector('[name="id"]').value,
            'quantity': document.querySelector('[data-product-qty]').value,
        }

        if (this.attachments.length > 0) {
            data.properties = {
                "_add_ons": self.attachmentOptions.join('|'),
            }
        }
        Shopify.itemsQueue.push(data);
        if (addedVariants.length > 0) {
            for (let i = 0; i < addedVariants.length; i++) {
                Shopify.itemsQueue.push(addedVariants[i]);
            }
        }
        Shopify.itemsAddNext = function () {
            if (Shopify.itemsQueue.length) {
                const request = Shopify.itemsQueue.shift();
                request.sections = self.isCartPage ? this.cartItems.getSectionsToRender().map((section) => section.section)
                    : self.cartNotification.getSectionsToRender().map((section) => section.id)

                fetch('/cart/add.js', {
                    body: JSON.stringify(request),
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest'
                    },
                    method: 'POST'
                }).then((response) => {
                    return response.json();
                }).then((response) => {
                    if (response.status) {
                        self.productForm.handleErrorMessage(response.description);
                        return;
                    }
                    if (Shopify.itemsQueue.length) {
                        Shopify.itemsAddNext();
                    } else {
                        const submitButton = document.querySelector('[type="submit"]');
                        self.cartNotification.renderContents(response);
                        self.cartNotification.open();
                        submitButton.classList.remove('loading');
                        submitButton.removeAttribute('aria-disabled');
                        document.querySelector('.loading-overlay').classList.add('loading-overlay_d-none');
                        self.num += 1;
                        self.recalculate(self);
                    }
                })
            }
        }
        Shopify.itemsAddNext();
    }
}

customElements.define('add-ons', AddOns);